( function( $, window ) {
	'use strict';

	$( function() {
		
	} );
} )( jQuery, window );
